import axios from "axios";
import qs from "qs";

export function postClientDataResponse(url, key, requestBody, onSuccess, onError) {
  let headers = {
    "x-api-key": key,
  };

  let dataToSend;

  if (requestBody instanceof FormData) {
    //  Handle file uploads
    headers["Content-Type"] = "multipart/form-data";
    dataToSend = requestBody;
  } else {
    //  Default: application/x-www-form-urlencoded
    headers["Content-Type"] = "application/x-www-form-urlencoded";
    dataToSend = qs.stringify(requestBody);
  }

  axios
    .create({
      responseType: "json",
      headers,
    })
    .post(url, dataToSend)
    .then((res) => {
      if (onSuccess) {
        onSuccess(res);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
}

export default postClientDataResponse;

/*import axios from "axios";
import qs from "qs";

export function postClientDataResponse(url, key, requestBody, onSuccess, onError) {
  axios
    .create({
      responseType: "json",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        "x-api-key": key,
      },
    })
    .post(url, qs.stringify(requestBody))
    .then((res) => {  
      if (onSuccess != null) {
        onSuccess(res);
      }
    })
    .catch((err) => {
      if (onError != null) {
        onError(err);
      }
    });
}

export default postClientDataResponse;*/

